module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C600"
  }, [_c('em', [_c('span', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Note ")]), _vm._v("on Translations ")])]), _vm._v(" "), _c('p', {
    staticClass: "P31"
  }, [_vm._v("In the interest of accessibility, all foreign-language texts appear in translation. I have used published translations where they exist; all other translations are my own. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecb98254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_Note_on.vue
// module id = 72
// module chunks = 0